export function livePreview(args) {
  const {
    prompt = null,
    rankingItem = null,
    placeholder = "",
    selectedOption = 0,
    showDeleteModal = false,
    deleteConfirmText = "",
    // Multilingual support
    langCodes = [],
    multilingualEnabled = false,
    translations = {},
    // Scale options for multilingual support
    scaleOptionsByLang = {},
    newScale = false,
    defaultLanguage = "en",
    surveyPrompts = {},
  } = args;

  return {
    prompt,
    rankingItem,
    placeholder,
    selectedOption,
    showDeleteModal,
    deleteConfirmText,
    // Multilingual support
    activeLanguage: defaultLanguage,
    defaultLanguage,
    langCodes,
    multilingualEnabled,
    translations,
    scaleOptionsByLang,
    newScale,
    surveyPrompts,
    surveyPrompt(key) {
      return (
        this.surveyPrompts[this.activeLanguage]?.[key] ||
        this.surveyPrompts[this.defaultLanguage]?.[key] ||
        ""
      );
    },
    get currentScaleOptions() {
      if (
        !this.scaleOptionsByLang ||
        Object.keys(this.scaleOptionsByLang).length === 0
      ) {
        return [];
      }
      return (
        this.scaleOptionsByLang[this.activeLanguage] ||
        this.scaleOptionsByLang[this.defaultLanguage] ||
        []
      );
    },
    hasTranslation(lang) {
      const t = this.translations[lang];
      if (!t || !t.prompt) return false;
      // If we have ranking and it needs translation too
      if (this.rankingItem && !t.ranking_item) return false;
      return true;
    },
    get allTranslated() {
      if (!this.multilingualEnabled || this.langCodes.length === 0) return true;
      return this.langCodes.every((lang) => this.hasTranslation(lang));
    },
  };
}
